import React, { useState, useEffect } from 'react';


import './index.scss';
import axiosInstance from '../../../../services/api/API';
import CustomTable from '../../../../customComponents/CustomTable';
import { useNavigate } from 'react-router-dom';
import ListFilters from '../../../Admin/OnBoardManagement/ListFilters';
// import editIcon from '../../../../../Assets/icons/Un-Checkbox.svg'; 
import viewIcon from '../../../../../Assets/icons/eye 1.svg'; 
import moment from 'moment';
import ListLogisticsFilters from '../../../Logistics/LogisticsFilter';
import searchIcon from "../../../../../Assets/icons/searchicon.svg";
import { IoMdClose } from "react-icons/io";
import SearchInput from '../../../../customComponents/CustomSearch/SearchInput';
// Un-Checkbox.svg
const TechnicianList = () => {
  const [jobCardData, setJobCardData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [technicianList,setTechnicianList] = useState([]);
  const [totalRecords,setTotalRecords] = useState(0);
  const [filterList,setFilterList] =useState();
  const [totalData,setTotalData] =useState(null);
  const [loaderTable,setLoaderTable] = useState(false)
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  const [ filterFormData, setFilterFormData ] = useState({})
  const [validationErrors, setValidationErrors] = useState({});
  const [ filters, setFilters ] = useState({})

  useEffect(() => {
    fetchJobCardList();
  }, [filterList]);
 
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchJobCardList(10,newPage)
  };

const onClickNavigetion=(item)=>{
  return(
    <div onClick={()=>handleEdit(item)}>
      <span > {item?.job_card_no}</span>
      </div>
  )
}

  const fetchJobCardList= async (page = 0, pageSize = 10) => {
    const allfilteredData = filters;
    const payload={
      //filterList
        business_partner_id:1,
        fromDate: allfilteredData?.fromDate?allfilteredData?.fromDate:"" ,
        toDate: allfilteredData?.toDate?allfilteredData?.toDate:"" ,
        orderBy:"job_card_id desc",
        page,
        pageSize,
        searchText:searchTerm
  }
    try {
      setLoaderTable(true)
      const response = await axiosInstance.post('/technician/techniciantodolist', payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });
      setLoaderTable(false)
      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr_No": index + 1,
        status:item?.solved === 0 ? 'Pending': 'Done',
        job_card_no:onClickNavigetion(item),
        'transaction_date': moment(item?.transaction_date).format('DD/MM/YYYY'),
      }));
      setTotalRecords(response?.data?.data?.totalRecords);
      setTechnicianList(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
      setTotalData(response?.data?.data);
    } catch (error) {
      console.error('Error fetching business partners:', error);
    }
  };

  const handleEdit = (rowData) => {
   navigate('technician-details',{state:{ data: JSON.parse(JSON.stringify(rowData)) } });
  };

  const Job_Card_TABLE_HEADERS = [
    "Job Card No.",
    // "Business Partner ID",
    "Job Card Date",
    "Customer Name",
    "Registration No.",
    "Vehicle Type",
    "Supervisor Name",
    "Technician Name",
    "Status",
    "Action"
  ];


  // Key mapping for CustomTable component
  const BUSINESS_PARTNER_KEY_MAPPING = {
    "Job Card No.": "job_card_no",
    // "Business Partner ID": "onboard_id",
    "Job Card Date": "transaction_date",
    "Customer Name": "customer_name",
    "Registration No.":"registration_no",
    "Vehicle Type": "product_name",
    "Supervisor Name":"supervisor_name",
    "Technician Name":"technician_name",
   
    "Status":"status",
    "Action": [
        { type: "view", 
           icon: viewIcon, 
          label: "View" },
    ]
  };


useEffect(() => {
  fetchJobCardList()
},[filters])
useEffect(() => {
  if (searchTerm === "") {
    fetchJobCardList();
  }
}, [searchTerm]);

const clearFilter = () => {
  setFilterFormData({})
  setFilters({});
  fetchJobCardList();
};

const PhysicalStockTakingInputs = [
  {
    name: "startDate",
    label: "From Date",
    type: "date",
    maxDate: new Date(),  
    required: true,
    gridClass: "col-lg-4",
  },
  {
      name: "endDate",
      label: "To Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-lg-4",
  }
]

const handleSearch = () => {
  // Update the filters state with the current form data
  setFilters({
    fromDate: filterFormData.startDate || null,
    toDate: filterFormData.endDate || null,
  });

  // Call fetchDealers to fetch the data with updated filters
  // fetchDealers(0, 10);
};

const handleSearchInputChange=(event)=>{
  setSearchTerm(event?.target?.value)
}

const handleKeyDown=(event)=>{
  if(event?.key==="Enter"){
    fetchJobCardList();
  }
}

const clearSearchAndFetch=()=>{
  setSearchTerm("")
}

  return (
    <div>
      <div className='OnboardManagamentContainer '>
        <div className='OnboardManagamentbuttonContainer col-md-3  mt-2 mb-2'>
          <h5 style={{fontWeight:"600"}} >Technician To Do</h5>
        </div>
        <div className=" col-md-8 mt-2 mb-2 totalvaluescontainer ">
          <div className="topleftdataContainer">
            <div className="listTopDataValueText">{totalData?.total || 0}</div>
            <div>Total Job</div>
          </div>

          <div className="topleftdataContainer">
            <div className="listTopDataValueText"> {  totalData?.total_pending || 0}</div>
            <div>Pending Job</div>
          </div>
          <div
            // key={}
            className="topleftdataContainer"
            style={{paddingRight:"10px"}}
          >
            <div className="listTopDataValueText">{totalData?.total_completed  || 0}</div>
            <div>Completed Job</div>
          </div>
          <div
            // key={}
          className="topleftdataContainer"
            style={{paddingRight:"10px"}}
          >
            <div className="listTopDataValueText">&#8377;{totalData?.total_revenue  || 0}</div>
            <div>Revenue</div>
          </div>
          
        </div>
      </div>
      <div className='tableWrapper'>
        <div className='filterView '>
          <div className='filterLeftView pt-4 col-md-4 gap-2'>
            <h5 style={{fontWeight:"600"}}>Technician To Do List</h5>
            <div>
              <SearchInput
                placeholder="Search Customer Name"
                onSearch={fetchJobCardList}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </div>
          </div>
          <div className='filterRightView col-md-8 gap-2'>
          <h5 style={{paddingTop:"30px"}} >Filter By</h5>
          {/* <ListFilters handleSearch={onclickFilter} clearSearch ={clearSearch}/> */}
          <ListLogisticsFilters 
      formConfig={PhysicalStockTakingInputs} 
      formData={filterFormData}
      setFormData={setFilterFormData}
      validationErrors={validationErrors}
      setValidationErrors={setValidationErrors}
      handleSearch={handleSearch}
      handleClear={clearFilter}
      // onSubmit={handleFormSubmit} 
      />
          </div>
        </div>
        <CustomTable 
          data={technicianList} 
          headers={Job_Card_TABLE_HEADERS} 
          keyMapping={BUSINESS_PARTNER_KEY_MAPPING} 
           //onEdit={handleEdit}  // Pass the handleEdit function
          itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          handleViewButton={handleEdit}
          totalRecords={totalRecords}
          tableLoaderShow={loaderTable}
          
        />
      </div>
    </div>
  );
};

export default TechnicianList;
